import { render } from "./GesMemorias.vue?vue&type=template&id=7dc1c2ea&scoped=true"
import script from "./GesMemorias.vue?vue&type=script&lang=js"
export * from "./GesMemorias.vue?vue&type=script&lang=js"

import "./GesMemorias.vue?vue&type=style&index=0&id=7dc1c2ea&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7dc1c2ea"

export default script